import { render, staticRenderFns } from "./Scoreboard.vue?vue&type=template&id=ddbf1c3a&scoped=true&"
import script from "./Scoreboard.vue?vue&type=script&lang=ts&"
export * from "./Scoreboard.vue?vue&type=script&lang=ts&"
import style0 from "./Scoreboard.vue?vue&type=style&index=0&id=ddbf1c3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbf1c3a",
  null
  
)

export default component.exports